import React, {Component} from 'react';
import {Link, withRouter} from 'react-router';
import T from 'i18n-react';
import {connect} from 'react-redux';
// Store action
import {setLanguage} from '../../store/language/LanguageActions'
// Enums
import PROFILES from '../../enums/ProfileEnum';
import PAGES from '../../enums/PageEnum';
import LOCATIONS from '../../enums/Location';
// Style
import './MenuTop.css';
import {grey50} from 'material-ui/styles/colors';
// Components
import LanguageMenu from '../languageMenu/LanguageMenu';
import FontIcon from 'material-ui/FontIcon';
import StoreIcon from 'material-ui/svg-icons/action/store';
import ImportIcon from 'material-ui/svg-icons/action/description';
import Popover from 'material-ui/Popover';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import MenuItem from 'material-ui/MenuItem';
import Menu from 'material-ui/Menu';

const mapStateToProps = (state) => ({
    login: state.userState.login,
    canManageUsers: state.userState.userData.canManageUsers,
    languageStore: state.languageState,
    businessUnit: state.userState.userData.businessUnit ? state.userState.userData.businessUnit.name : undefined,
    clientList: state.userState.userData.clientList ? state.userState.userData.clientList : []
});

const mapDispatchToProps = (dispatch) => ({
    setLanguage: (language) => dispatch(setLanguage(language))
});

class MenuTop extends Component {

    constructor(props) {
        super(props);

        this.state = {
            popoverOpen: false,
        };
    }

    isUserAdminMp(){
        return this.props.userProfile === PROFILES.ADMIN_MP;
    }

    canAccessTransactionTabs() {
        return this.props.clientList.find(client => client.location === LOCATIONS.FR || client.location === LOCATIONS.BE);
    }

    canAccessInvoicePage() {
        return this.props.userProfile === PROFILES.SUPER_USER || this.props.userProfile === PROFILES.ADMIN || this.props.userProfile === PROFILES.ADMIN_MP;
    }

    getProfileName() {
        const {userProfile} = this.props;
        if (this.props.businessUnit) {
            return (
                <span>
                    <span>{T.translate("userProfile." + userProfile) + ' - '}</span>
                    <b>{this.props.businessUnit}</b>
                </span>
            );
        }
        return T.translate("userProfile." + userProfile);
    }

    render() {
        const shopPageActive = this.props.location.pathname ===  PAGES.SHOP_PAGE;
        const jobHistoryActive = this.props.location.pathname ===  PAGES.JOB_HISTORY;
        const jobHistoryActiveClassName = jobHistoryActive ? 'selected' : '';
        const shopPageActiveClassName = shopPageActive ? 'selected' : '';
        const adminPageActiveClassName = jobHistoryActive || shopPageActive ? 'selected' : '';
        return(
            <div className="menu-top">
                <div className="menu">
                    <Link to={PAGES.HOME_PAGE} activeClassName="selected" onlyActiveOnIndex>
                        <FontIcon title={T.translate("menuTop.reporting")} className="material-icons" color="inherit">today</FontIcon>
                        <span>{T.translate("menuTop.reporting")}</span>
                    </Link>
                    <Link to={PAGES.REPORTING_PERIODIC_PAGE} activeClassName="selected" onlyActiveOnIndex>
                        <FontIcon title={T.translate("menuTop.reportingPeriodic")} className="material-icons" color="inherit" >date_range</FontIcon>
                        <span>{T.translate("menuTop.reportingPeriodic")}</span>
                    </Link>
                    {this.canAccessTransactionTabs() ?
                        <Link to={PAGES.TRANSACTION_PAGE} activeClassName="selected" onlyActiveOnIndex>
                            <FontIcon title={T.translate("menuTop.transactionAccepted")} className="material-icons"
                                      color="inherit">playlist_add_check</FontIcon>
                            <span>{T.translate("menuTop.transactionAccepted")}</span>
                        </Link> : null}
                    {this.canAccessTransactionTabs() ?
                        <Link to={PAGES.FINANCED_TRANSACTION_PAGE} activeClassName="selected" onlyActiveOnIndex>
                        <FontIcon title={T.translate("menuTop.transactionFinanced")} className="material-icons" color="inherit">playlist_add_check</FontIcon>
                        <span>{T.translate("menuTop.transactionFinanced")}</span>
                    </Link> : null}
                    {this.props.canManageUsers ?
                            <Link to={PAGES.USER_MANAGER} activeClassName="selected" onlyActiveOnIndex>
                                <FontIcon title={T.translate("menuTop.userManagement")} className="material-icons" color="inherit">people</FontIcon>
                                <span>{T.translate("menuTop.userManagement")}</span>
                            </Link>
                        : null
                    }
                    {this.canAccessInvoicePage() ?
                        <Link to={PAGES.INVOICE_PAGE} activeClassName="selected" onlyActiveOnIndex>
                            <FontIcon title={T.translate("menuTop.invoicePage")} className="material-icons" color="inherit">receipt</FontIcon>
                            <span>{T.translate("menuTop.invoicePage")}</span>
                        </Link>
                        : null
                    }
                    {this.isUserAdminMp() ?
                        <Link className={"adminMenu " + adminPageActiveClassName} onlyActiveOnIndex onClick={this.handleTouchTap}>
                            <FontIcon title={T.translate("menuTop.admin")} className="material-icons" color="inherit">settings</FontIcon>
                            <span>{T.translate("menuTop.admin")}</span>
                            <Popover
                                open={this.state.popoverOpen}
                                anchorEl={this.state.anchorEl}
                                anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                                targetOrigin={{horizontal: 'left', vertical: 'top'}}
                                onRequestClose={this.handleRequestClose}
                            >
                                <Menu>
                                    <MenuItem
                                        className={"menuItemLink " + jobHistoryActiveClassName}
                                        leftIcon={<ImportIcon/>}
                                        primaryText={T.translate("menuTop.jobHistory")}
                                        onTouchTap={() => this.redirectFromMenuItem(PAGES.JOB_HISTORY)}/>
                                    <MenuItem
                                        className={"menuItemLink " + shopPageActiveClassName}
                                        leftIcon={<StoreIcon/>}
                                        primaryText={T.translate("menuTop.shopPage")}
                                        onTouchTap={() => this.redirectFromMenuItem(PAGES.SHOP_PAGE)}/>
                                </Menu>
                            </Popover>
                        </Link>
                        : null
                    }
                </div>
                <div className="user">
                    <div className="user-side">
                        <div className="user-menu">
                        <MenuItem
                            primaryText={this.props.login}
                            rightIcon={<ArrowDropDown color={grey50}/>}
                            menuItems={[
                                <MenuItem primaryText={T.translate("menuTop.editMyUser")} onTouchTap={() => this.redirectFromMenuItem(PAGES.EDIT_MY_ACCOUNT)} />,
                                <MenuItem primaryText={T.translate("menuTop.editMyPassword")} onTouchTap={() => this.redirectFromMenuItem(PAGES.EDIT_MY_PASSWORD)} />,
                                <MenuItem primaryText={T.translate("menuTop.disconnect")} onTouchTap={() => this.props.redirectLogin()}/>
                            ]}
                            targetOrigin={{horizontal: 'right', vertical: 'bottom'}}
                            style={{color: grey50}}
                        />
                        </div>
                        <span className="user-fonction">{this.getProfileName()}</span>
                    </div>
                    <div className="separator"/>
                    <div className="lang">
                        <FontIcon className="material-icons" color="inherit">person_outline</FontIcon>
                        <LanguageMenu selectedItem={this.props.languageStore.language} onChangeAction={this.props.setLanguage} top={true}/>
                    </div>
                </div>
            </div>
        );
    }

    /**********************************************************
     * **************** Gestion Menu Admin ********************
     **********************************************************/

    redirectFromMenuItem(page){
        this.setState({
            popoverOpen: false
        }, () => this.props.router.push(page));
    }

    handleTouchTap = (event) => {
        event.preventDefault();

        this.setState({
            popoverOpen: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            popoverOpen: false,
        });
    };

}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(MenuTop));



// WEBPACK FOOTER //
// ./src/components/menuTop/MenuTop.js